module.exports = __webpack_public_path__ + "img/cilinder-image.0d095bbc.png";